import TrackingManager, { TApplicationInsightsConfig } from '@ingeniorforeningen/tracking';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { type ITelemetryPlugin } from '@microsoft/applicationinsights-core-js';

export const reactPlugin = new ReactPlugin();

const useGtmProdContainer = process.env.NEXT_PUBLIC_USE_GTM_PROD_CONTAINER === 'true';
const trackingLanguage = 'da'
const cloudRoleName = 'InsuranceUI';
const connectionString: string = process.env.NEXT_PUBLIC_APP_INSIGHTS_CONNECTIONSTRING as string;

const applicationInsightConfig: TApplicationInsightsConfig = {
  connectionString,
  cloudRoleName,
  extensions: [reactPlugin as unknown as ITelemetryPlugin],
  enableAutoRouteTracking: true,
};

const tracker = () =>  {
  TrackingManager.init(useGtmProdContainer, "idaforsikring.dk", trackingLanguage, applicationInsightConfig);

  return {
    trackPageView: (name: string, id: string, locale: "da" | "en") => {
      if (name && id) {
        TrackingManager.Instance.page.view({
          pageTitle: name,
          nodeId: id,
          section: 'ida forsikring',
          locale,
        });
        TrackingManager.Instance.monitor?.trace({
          message:"pageview",
          properties:{
            pageTitle: name,
            nodeId: id,
            section: 'ida forsikring',
          },
          severityLevel:3,
        })
      }
    },
    trackPageError: (errorcode: number, properties?: Record<string, unknown>) => {
      TrackingManager.Instance.page.error({
        errorcode,
        properties,
        severityLevel: 3,
      });
    },
  
    monitor: TrackingManager.Instance.monitor,
  }
};

export default tracker;
